import { useCleanFilterForRequest, useFilterState } from '@btime/react-contexts'
import React from 'react'

import ServiceOrdersLoader from './_load/ServiceOrdersLoader'
import ServiceOrdersTable from './table/ServiceOrdersTable'
import MultiSelectHandler from '../../../packages/kiti/components/multiSelect/MultiSelectHandler'
import MultiRowsActions from './table/MultiRowsActions'
import ControlBar from '../shared/ControlBar'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'

const PageContent = ({ id }) => {
  useLocalStorageWatcher('LAST_PROCESS_VIEW_MODE', 'list')
  const filter = useCleanFilterForRequest()
  const { search, searchType } = useFilterState()

  return (
    <MultiSelectHandler>
      <ControlBar hideFastFilters selectedScreen={`/processes/list/${id}`} />
      <ServiceOrdersLoader
        uncontrolledChildren={<MultiRowsActions />}
        search={search}
        searchType={searchType}
        filter={filter}
      >
        <ServiceOrdersTable />
      </ServiceOrdersLoader>
    </MultiSelectHandler>
  )
}

export default PageContent
